<template>
  <div class="device-select">
    <el-dialog title="选择设备" :visible.sync="deviceVisible" append-to-body :close-on-click-modal="deviceModalClose"
      @close="handleSelectCancel" width="50%">
      <el-form :model="queryForm" ref="queryForm" :inline="true">
        <el-form-item label="设备名称">
          <el-input v-model="queryForm.deviceName" placeholder="请输入设备名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearchDevice">查询</el-button>
          <el-button @click="handleResetDevice">重置</el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-table ref="tableRef" :data="deviceData" @selection-change="handleSelectionChange"
          style="width: 100%; max-height: 470px; overflow-y: auto;">
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-radio v-model="selectRadio" :label="scope.row">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="序号" type="index" width="70"></el-table-column>
          <el-table-column label="设备编码" prop="deviceId" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备名称" prop="deviceName" width="280" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备类型" prop="deviceTypeName" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备状态" prop="statusName" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备位置" prop="location" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSelectConfirm">确 定</el-button>
        <el-button @click="handleSelectCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
export default {
  name: 'DeviceSelect',
  props: {
    selectCamera: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 选择设备
      deviceVisible: false,
      deviceModalClose: false,
      queryForm: {
        deviceName: ''
      },
      // 设备类型
      deviceTypeList: [],
      // 设备列表
      deviceData: [],
      // 选中项
      selectRadio: '',
      confirmArr: []
    }
  },
  created() {
    this.queryDeviceList()
  },
  methods: {
    openDialog() {
      this.deviceVisible = true;
      this.$nextTick(() => {
        let idArr = []
        idArr.push(this.selectCamera)
        if (this.selectCamera != '') {
          this.deviceData.forEach(d => {
            if (idArr.includes(d.deviceId)) {
              this.selectRadio = d
            }
          })
        }
      })
    },
    handleSelectionChange(row) {
      this.selectRadio = row
    },
    // 查询设备
    queryDeviceList() {
      this.$fetch(api.getDeviceList, {
        page: 1,
        pageSize: 1000,
        deviceType: "18",
        deviceName: this.queryForm.deviceName
      }).then((res) => {
        if (res.success) {
          this.deviceData = res.returnObj.list
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 查询所有设备
    handleSearchDevice() {
      this.queryDeviceList();
    },
    // 重置查询所有设备
    handleResetDevice() {
      this.queryForm.deviceName = ''
      this.queryDeviceList();
    },
    handleSelectCancel() {
      this.selectRadio = '';
      this.deviceVisible = false;
    },
    // 传值
    handleSelectConfirm() {
      if (this.selectRadio == '') {
        this.$message({
          message: '请选择设备',
          type: 'warning'
        });
        return
      }
      this.$emit('selectArr', this.selectRadio)
      this.handleSelectCancel();
    }
  }
}
</script>
